export const movieDirection = [
  {
    name: "Popular",
    to: "/movie/popular/1",
    keyword: "popular",
    category: "movie",
  },
  {
    name: "Now Playing",
    to: "/movie/now_playing/1",
    keyword: "now_playing",
    category: "movie",
  },
  {
    name: "Upcoming",
    to: "/movie/upcoming/1",
    keyword: "upcoming",
    category: "movie",
  },
  {
    name: "Top Rated",
    to: "/movie/top_rated/1",
    keyword: "top_rated",
    category: "movie",
  },
];
export const tvDirection = [
  {
    name: "Top Rated",
    to: "/tv/top_rated/1",
    keyword: "top_rated",
    category: "tv",
  },
  {
    name: "Popular",
    to: "/tv/popular/1",
    keyword: "popular",
    category: "tv",
  },
  {
    name: "Airing Today",
    to: "/tv/airing_today/1",
    keyword: "airing_today",
    category: "tv",
  },
  {
    name: "On TV",
    to: "/tv/on_the_air/1",
    keyword: "on_the_air",
    category: "tv",
  },
];
